import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { BackendDataShape, UsedAPI } from "api/config";
import CookieMonster from "api/CookieMonster";

import { convertToEncodedURL } from "assets/usefulFunctions";

import {
  APaginationEntity,
  BackendDataPageShape,
  BackendPaginationRequestObject,
} from "types";
import {
  IDataOperation,
  IGetOperationChecksReqObj,
  IOperationChecks,
} from "types/endpoints/pesawatUdara";

export const operationCheckStoreAPI = createApi({
  reducerPath: "operationCheckStoreAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: `${UsedAPI}`,
    prepareHeaders: (headers) => {
      let token = CookieMonster.loadCookie("jwt");
      headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["OperationCheckList"],
  endpoints: (builder) => {
    return {
      getOperationCheckPagination: builder.query<
        APaginationEntity<IOperationChecks[]>,
        BackendPaginationRequestObject<Partial<IGetOperationChecksReqObj>>
      >({
        query: (obj) => {
          let params = "";
          if (obj) {
            params = convertToEncodedURL(obj);
            params = params.length ? "?" + params : "";
          }
          let url = "/operations/checks" + params;
          return {
            url,
            method: "GET",
          };
        },
        transformResponse: (
          response: BackendDataPageShape<IOperationChecks[]>,
        ) => response.data,
        providesTags: (_, __, { id }) => [
          "OperationCheckList",
          { type: "OperationCheckList", id },
        ],
      }),
      updateOperationCheck: builder.mutation<
        BackendDataShape<string>,
        {
          id: number;
          praOrPasca: "pra" | "pasca";
          data: Partial<IDataOperation>;
        }
      >({
        query: ({ id, praOrPasca, data }) => {
          return {
            url: `/operation/${id}/checks/${praOrPasca}`,
            body: data,
            method: "PATCH",
          };
        },
        invalidatesTags: ["OperationCheckList"],
      }),
    };
  },
});

export const {
  useGetOperationCheckPaginationQuery,
  useUpdateOperationCheckMutation,
  util: { resetApiState: resetOperationCheckStoreAPI },
} = operationCheckStoreAPI;
